/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_YesInputs */

const en_directory_knowledge_yes = /** @type {(inputs: Directory_Knowledge_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const zh_directory_knowledge_yes = /** @type {(inputs: Directory_Knowledge_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Directory_Knowledge_YesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_yes = /** @type {((inputs?: Directory_Knowledge_YesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_YesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_yes(inputs)
	return zh_directory_knowledge_yes(inputs)
});
export { directory_knowledge_yes as "directory.knowledge.yes" }